var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from 'react';
import { UtilityNav } from '../UtilityNav';
var UtilityNavDesktop = /** @class */ (function (_super) {
    __extends(UtilityNavDesktop, _super);
    function UtilityNavDesktop(props) {
        var _this = _super.call(this, props) || this;
        _this.tabletBreakpoint = 1219; // 991
        var smallerThanTabletBreakpoint = document.documentElement.clientWidth <= _this.tabletBreakpoint ? true : false;
        _this.state = {
            isTablet: smallerThanTabletBreakpoint
        };
        _this.onComponentResize = _this.onComponentResize.bind(_this);
        return _this;
    }
    UtilityNavDesktop.prototype.onComponentResize = function () {
        // console.log("oncomponentresize");
        var smallerThanTabletBreakpoint = document.documentElement.clientWidth <= this.tabletBreakpoint ? true : false;
        this.setState({
            isTablet: smallerThanTabletBreakpoint
        });
    };
    UtilityNavDesktop.prototype.componentDidMount = function () {
        var _this = this;
        window.addEventListener('resize', function () { _this.onComponentResize(); });
    };
    UtilityNavDesktop.prototype.componentWillUnmount = function () {
        var _this = this;
        // remove the resize listener when this component is unmounted
        window.removeEventListener('resize', function () {
            _this.onComponentResize();
        });
    };
    UtilityNavDesktop.prototype.render = function () {
        // console.log(this.state);
        if (!this.state.isTablet) {
            return (React.createElement(UtilityNav, null));
        }
        else {
            return (React.createElement(React.Fragment, null));
        }
    }; // end render()
    return UtilityNavDesktop;
}(React.Component));
export { UtilityNavDesktop };
